import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { saveAs } from 'file-saver';

import { AcoesComponent } from '../../../acoes/acoes.component';
import { AcoesService } from '../../../acoes/acoes.service';
import { AutenticacaoService } from '../../../autenticacao/autenticacao.service';
import { EventEmitterService } from '../../../base/util/event-emitter.service';
import { BuscaGtoResponse } from '../../../base/vo/buscaGtoResponse';
import { FiltroBuscaGto } from '../../../base/vo/filtro-busca-gto';
import { BuscarGtoService } from './buscar-gto.service';


@Component({
  selector: 'app-buscar-gto',
  templateUrl: './buscar-gto.component.html',
  styleUrls: ['./buscar-gto.component.css']
})
export class BuscarGtoComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('acoes')
  public acoes: AcoesComponent;

  constructor(public buscarGtoService: BuscarGtoService, public router: Router, public acoesService: AcoesService,
    public eventEmitterService: EventEmitterService, public autenticacaoService: AutenticacaoService) { }

  @Input() tipoBusca: string;
  @Output() isLoading = new EventEmitter<boolean>(false);

  loading = false;
  loadingPaginado = false;
  loadingAcoes = false;
  key: any;
  isDesc = false;
  direction: number;
  onlyNumberPattern = /([0-9])\w+/;
  gtoFiltro = new FiltroBuscaGto();
  gtoList = new BuscaGtoResponse();
  total: number;

  prestadorExecutanteList: any;
  prestadorExecutanteResults: any;

  dataInicialFiltro: Date;
  dataFinalFiltro: Date;
  dataInicialFinalString = '';
  dataValid = true;
  erroData = '';

  displayFiltro = true;
  paginado = true;
  resultadoEncontrado = 0;
  situacaoList: any;
  oldSituacao: any;

  subs: Subscription[] = [];

  errors: any;

  ptbr = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto',
      'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  cols = [
    { field: 'nomeBeneficiario', header: 'Nome Beneficiário' },
    { field: 'codigoBeneficiario', header: 'Cod. Beneficiário' },
    { field: 'numero', header: 'Nº da GTO' },
    { field: 'status', header: 'Status' }
  ];

  // Variaveis datepicker
  dataOverlay = false;
  dataOverlayAnimation = false;

  ngOnInit() {
    if (this.tipoBusca === '2' || this.tipoBusca === '3') {
      this.loading = true;
      this.disableButtons();
    }
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  ngAfterViewInit() {
    const efetuarBuscaGto = JSON.parse(localStorage.getItem('efetuar-busca-gto'));
    const gtoFiltroTmp = JSON.parse(localStorage.getItem('filtro-busca-gto'));

    if (efetuarBuscaGto && gtoFiltroTmp != null) {

      localStorage.removeItem('efetuar-busca-gto');
      this.gtoFiltro = gtoFiltroTmp;
      this.tipoBusca = this.gtoFiltro.tipoBusca;
      this.carregaCombos();
      if (this.gtoFiltro.dataInicial && this.gtoFiltro.dataFinal) {
        this.dataInicialFiltro = new Date(this.gtoFiltro.dataInicial);
        this.dataFinalFiltro = new Date(this.gtoFiltro.dataFinal);
        this.aplicarDatas();
      }
      this.callBuscarGto();

    } else {
      // Tipo abas: 1-buscarGTO, 2-minhasGTOS, 3-pendentes

      this.gtoFiltro.tipoBusca = this.tipoBusca;
      this.carregaCombos();

      if (this.gtoFiltro.tipoBusca === '2') {
        this.buscarGTOFixo();
      } else if (this.gtoFiltro.tipoBusca === '3') {
        this.subs.push(this.buscarGtoService.countPendentes().subscribe(
          data => {
            this.eventEmitterService.change(data.data);
            this.buscarGTOFixo();
          },
          error => {
            console.log('Count pendentes false');
          }));
      }
    }
  }

  carregaCombos() {
    if (this.gtoFiltro.tipoBusca === '1') {
      // Carrega as situações das gtos disponíveis.
      this.buscarGtoService.situacaoGTODropdown().subscribe(
        data => {
          this.situacaoList = data.data;
        },
        error => { console.log('Erro ao carregar situações da GTO.'); });

      if (this.autenticacaoService.isClinica) {
        // Carrega o autocomplete de prestadores executantes
        this.buscarGtoService.prestadorExecutanteList().subscribe(
          data => {
            this.prestadorExecutanteList = data.data;
          },
          error => { console.log('Erro ao carregar lista prestadores executantes.'); });
      }

    }
  }

  changeSituacao(event) {
    if (this.gtoFiltro.status === '-1') {
      this.gtoFiltro.status = undefined;
      event.target.value = '0: undefined';
    }
  }

  // BuscarGTO com filtros dinâmicos, usando controle de form...
  buscarGTO(f) {
    this.errors = null;
    if (f.form.valid && this.validarData() && !this.loading) {
      this.gtoFiltro.nPagina = 1;
      this.callBuscarGto();
    }
  }

  callBuscarGto() {
    this.loading = true;
    this.disableButtons();
    this.subs.push(this.buscarGtoService.buscarGto(this.paginado, this.gtoFiltro).subscribe(
      data => {
        this.controleFiltro(data, true);
      },
      errorResponse => {
        this.loading = false;
        this.disableButtons();
        this.resultadoEncontrado = 0;
        this.displayFiltro = false;

        if (errorResponse.error && errorResponse.error.errors.length > 0) {
          this.errors = errorResponse.error.errors;
        }
      }
    ));
  }

  novaBusca() {
    // limpar filtro e enviar para a tela inicial.
    this.limparDatas();
    this.direction = null;
    this.isDesc = null;
    this.key = null;
    this.gtoFiltro = new FiltroBuscaGto();
    this.gtoFiltro.nPagina = 1;
    this.gtoList = new BuscaGtoResponse();
    this.displayFiltro = true;
    this.resultadoEncontrado = 0;
    localStorage.removeItem('filtro-busca-gto');
  }

  voltar() {
    this.displayFiltro = true;
    this.resultadoEncontrado = 0;
    this.gtoList = new BuscaGtoResponse();
  }

  exportarExcel() {
    this.loading = true;
    this.disableButtons();
    this.loadingPaginado = true;
    this.buscarGtoService.downloadExcel(this.gtoFiltro).subscribe(
      data => {
        this.loading = false;
        this.loadingPaginado = false;
        this.disableButtons();
        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'exportar-dados.csv');
      },
      erro => {
        this.loading = false;
        this.loadingPaginado = false;
        this.disableButtons();
        console.log('Não foi possível fazer download.');
      });
  }

  detalhes(numeroGTO) {
    this.router.navigate(['/detalhagto'], { queryParams: { numeroGTO: numeroGTO } });
  }

  limparDatas() {
    this.dataFinalFiltro = null;
    this.dataInicialFiltro = null;
    this.gtoFiltro.dataFinal = null;
    this.gtoFiltro.dataInicial = null;
    this.dataInicialFinalString = '';
    this.validarData();
    this.dataOverlayVisivel(false);
  }

  aplicarDatas() {
    this.validarData();
    if (this.dataInicialFiltro != null && this.dataFinalFiltro != null) {
      this.gtoFiltro.dataInicial = this.dataInicialFiltro;
      this.gtoFiltro.dataFinal = this.dataFinalFiltro;
      this.dataInicialFinalString =
        this.gtoFiltro.dataInicial.getDate() + '/' + (this.gtoFiltro.dataInicial.getMonth() + 1) + '/' +
        this.gtoFiltro.dataInicial.getFullYear() + ' até ' + this.gtoFiltro.dataFinal.getDate() + '/' +
        (this.gtoFiltro.dataFinal.getMonth() + 1) + '/' + this.gtoFiltro.dataFinal.getFullYear();
    }
    this.dataOverlayVisivel(false);
  }

  validarData() {
    this.dataValid = true;
    this.erroData = '';
    if (this.dataInicialFiltro != null && this.dataFinalFiltro == null) {
      this.erroData = 'Preencha a data final.';
      this.dataValid = false;
    } else if (this.dataInicialFiltro == null && this.dataFinalFiltro != null) {
      this.erroData = 'Preencha a data inicial.';
      this.dataValid = false;
    } else if (this.dataInicialFiltro > this.dataFinalFiltro) {
      this.erroData = 'Data final inferior a inicial.';
      this.dataValid = false;
    } else if (this.dataInicialFiltro != null && this.dataFinalFiltro != null) {
      const diff = (this.dataFinalFiltro.getTime() - this.dataInicialFiltro.getTime()) / (1000 * 60 * 60 * 24);
      if (diff > 90) {
        this.erroData = 'Período não deve ultrapassar 90 dias.';
        this.dataValid = false;
      }
    }

    return this.dataValid;
  }

  filtrosVazios() {
    if (this.gtoFiltro.codigoBeneficiario || this.gtoFiltro.nomeBeneficiario || this.gtoFiltro.numero ||
      (this.gtoFiltro.status != null && this.gtoFiltro.status !== '') ||
      (this.dataValid && this.dataInicialFinalString !== '') ||
      (this.gtoFiltro.prestadorExecutante != null)) {
      return true;
    }
    return false;
  }

  situacaoDescricao(codigo: string, dataFinalizacao: string) {

    switch (codigo) {
      case '1': {
        if (dataFinalizacao) {
          return 'Finalizada';
        }

        return 'Validada';
      }
      case '2': {
        return 'Pendente para Análise';
      }
      case '3': {
        return 'Cancelada';
      }
      case '4': {
        return 'Expirada';
      }
      case '5': {
        return 'Em análise';
      }
      case '6': {
        return 'Em consolidação';
      }
      case '7': {
        return 'Consolidada';
      }
      case '8': {
        return 'Concluída';
      }
      case '9': {
        return 'A ser recursada';
      }
      case '11': {
        return 'Finalizada';
      }
      default: {
        return '-';
      }
    }
  }

  sort(param: string): void {
    this.direction = this.isDesc ? 1 : -1;
    this.isDesc = !this.isDesc;
    this.key = param;
  }

  // Paginação
  pageChanged(page: number) {
    this.gtoFiltro.nPagina = page;
    this.loading = true;
    this.loadingPaginado = true;
    this.disableButtons();

    this.subs.push(this.buscarGtoService.buscarGto(this.paginado, this.gtoFiltro).subscribe(
      data => {
        this.controleFiltro(data, false);
        this.loadingPaginado = false;
        this.disableButtons();
      },
      errorResponse => {
        this.loading = false;
        this.disableButtons();
        this.resultadoEncontrado = 0;
        this.displayFiltro = false;
      }));
  }

  // Buscar minhas gtos e gtos pendentes, método sem validação de filtro
  buscarGTOFixo() {
    this.gtoFiltro = new FiltroBuscaGto();
    this.gtoFiltro.tipoBusca = this.tipoBusca;
    this.gtoFiltro.nPagina = 1;
    this.loading = true;
    this.disableButtons();
    // Aba pendentes
    if (this.tipoBusca === '3') {
      this.gtoFiltro.possuiObservacao = true;
    }

    this.subs.push(this.buscarGtoService.buscarGto(this.paginado, this.gtoFiltro).subscribe(
      data => {
        this.controleFiltro(data, true);
      },
      erro => {
        this.loading = false;
        this.disableButtons();
        this.resultadoEncontrado = 0;
        this.displayFiltro = false;
        console.log('Erro ao buscar GTO.');
      }));
  }

  controleFiltro(data, calcTotal) {
    this.loading = false;
    this.disableButtons();
    this.resultadoEncontrado = data == null ? 0 : data.data.list == null ? 0 : data.data.list.length;
    this.gtoList.listGto = data == null ? null : data.data.list;
    this.gtoList.qtdPagina = data == null ? null : data.data.qtdPaginas;
    if (calcTotal) {
      this.total = this.gtoList.qtdPagina * 5;
    }
    this.displayFiltro = false;
    this.disableButtons();
  }


  autoCompletePrestador(event) {
    this.prestadorExecutanteResults = this.prestadorExecutanteList.filter(
      item => item.nome.toUpperCase().indexOf(event.query.toUpperCase()) !== -1);
  }

  // Exibe ou esconde o datepicker
  dataOverlayVisivel(isVisible: boolean) {

    if (isVisible) {

      this.dataOverlay = isVisible;
      setTimeout(() => {
        this.dataOverlayAnimation = isVisible;
      }, 1);

    } else {

      this.dataOverlayAnimation = isVisible;
      setTimeout(() => {
        this.dataOverlay = isVisible;
      }, 200);
    }
  }

  hasError(fieldname) {
    if (this.errors && this.errors.length > 0) {
      let i;
      for (i = 0; i < this.errors.length; i++) {
        if (this.errors[i].field === fieldname) {
          return true;
        }
      }
    }
  }

  errorMsg(fieldname) {
    if (this.errors && this.errors.length > 0) {
      let i;
      for (i = 0; i < this.errors.length; i++) {
        if (this.errors[i].field === fieldname) {
          return this.errors[i].message;
        }
      }
    }
  }

  callbackOnAction(actionSuccess) {
    if (actionSuccess) {
      this.resultadoEncontrado = 0;
      this.callBuscarGto();
    }
  }

  callbackOnActionFinalizar(actionFinalizar) {
    if (actionFinalizar) {
      this.loadingAcoes = true;
    } else {
      this.loadingAcoes = false;
    }
  }

  disableButtons() {
    this.isLoading.emit(this.loading || this.loadingPaginado || this.loadingAcoes);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/gto-dashboard/buscar-gto/buscar-gto.component.ts